import { HttpErrorResponse } from '@angular/common/http';

export type ColorType = 'success' | 'error' | 'warning' | 'info' | '';

/** Estado de la constancia digital de entrega (back: DigitalReceiptStatusEnum). null = sin evento POD. */
export enum DigitalReceiptStatus {
  pending = 'Pending',
  available = 'Available',
  unavailable = 'Unavailable'
}

export enum StatusShipment {
  delivered = 'Delivered',
  confirmed = 'Confirmed',
  scheduledCollection = 'ScheduledCollection',
  toCollect = 'ToCollect',
  takeToDropOff = 'TakeToDropOff',
  canceled = 'Cancelled',
  dispatched = 'Dispatched',
  center = 'AtCenter',
  pickUp = 'ReadyForPickup',
  today = 'DeliveringToday',
  deliveredError = 'DeliveryFailed',
  retiredError = 'NotPickedUp',
  returnedOrigen = 'ReturnedToOrigin',
  returnError = 'ImpossibleReturn',
  pending = 'Pending',
  toPay = 'ToPay',
  paid = 'Paid',
  destribution = 'InDistribution',
  incident = 'ReportedIncident',
  notDispatched = 'NotDispatched',
  returnDispatched = 'ReturnDispatched',
  returnDeliveryImpossible = 'ReturnDeliveryImpossible',
  returnReadyForPickup = 'ReturnReadyForPickup',
  creditAccount = 'CreditAccount',
  visitedNotCollected = 'VisitedNotCollected',
  impossibleCollection = 'ImpossibleCollection'
}

export type TypeStatusShipment =
  | 'Delivered'
  | 'Confirmed'
  | 'ScheduledCollection'
  | 'ToCollect'
  | 'TakeToDropOff'
  | 'Cancelled'
  | 'Dispatched'
  | 'AtCenter'
  | 'ReadyForPickup'
  | 'InDistribution'
  | 'DeliveringToday'
  | 'DeliveryFailed'
  | 'NotPickedUp'
  | 'ReturnedToOrigin'
  | 'ImpossibleReturn'
  | 'ReportedIncident'
  | 'NotDispatched'
  | 'ReturnDispatched'
  | 'ReturnDeliveryImpossible'
  | 'ReturnReadyForPickup'
  | 'Pending'
  | 'ToPay'
  | 'Paid'
  | 'CreditAccount'
  | 'VisitedNotCollected'
  | 'ImpossibleCollection'

export type TypeCard = 'shipment' | 'return';

export type CardExtensionTravel = 'collapsed' | 'semi' | 'full';

export const CARD_EXTENSION_STATE = {
  COLLAPSED: 'collapsed' as CardExtensionTravel,
  SEMI: 'semi' as CardExtensionTravel,
  FULL: 'full' as CardExtensionTravel
};

export enum TypeCardEnum {
  shipment = 'shipment',
  return = 'return'
}

export enum TypeShipment {
  shipment = 'Envío',
  return = 'Devolución'
}

export enum TitleTableName {
  select = 'select',
  dateCreated = 'date',
  id = 'id',
  origin = 'origin',
  destination = 'destination',
  idTracking = 'idTracking',
  typeShipment = 'typeShipment',
  cost = 'cost',
  status = 'status',
  actions = 'actions'
}

export interface DataCard {
  id: number,
  visualId: string,
  isQuote: boolean,
  typeCard: TypeCard,
  completedName: string,
  idTracking: string | null,
  collectionDate: string,
  originName: string,
  origin: string,
  destination: string,
  status: StatusShipment,
  confirmDate?: string,
  deliveryDate?: string,
  category?: string,
  group?: string,
  dateCreated: string,
  dateStatus: string,
  totalCost: string,
  shippingDelivery: ShippingDelivery,
  isSendEmail?: boolean,
  externalPlatform: string | null,
  isManual?: boolean,
  digitalReceiptStatus?: DigitalReceiptStatus | null
}

export type ButtonSize = 'xsmall' | 'small' | 'medium' | 'large' | 'xlarge';
export type ButtonType =
  | 'filled'
  | 'filled-outlined'
  | 'outlined'
  | 'text'
  | 'rounded-filled'
  | 'rounded-filled-second'
  | 'rounded-outlined'
  | 'rounded-text'
  | 'outlined-hover';

export type ButtonCircleIcon = 'icon' | 'icon-filled' | 'icon-outlined';
export interface ModalConfirmData {
  image: string;
  option: string;
  secondButton: boolean;
  firstButton?: boolean;
  showCloseButton?: boolean;
  typePoint?: string;
  minimumShipmentsRequired?: number;
  messageOther?: boolean;
  userTimeLocked?: string;
  id?: string;
  customTitle?: string;
}

export enum TypeCardExtension {
  pendingPayment = 'pendingPayment',
  errorPayment = 'errorPayment',
  onTravel = 'onTravel',
  finished = 'finished',
  confirmed = 'confirmed'
}

export interface DataCardExtension {
  id: number,
  visualId: string,
  isQuote: boolean,
  typeStatus: TypeStatusShipment,
  status: string,
  name: string,
  idTracking: string,
  productName: string,
  contact: Contact,
  addressOrigin: AddressContact,
  addressDestination: AddressContact,
  shipment: Shipment,
  isReturn?: boolean,
  externalPlatform: string | null,
  digitalReceiptStatus?: DigitalReceiptStatus | null
}

export interface Contact {
  name: string,
  email: string,
  phone: string,
}
export interface AddressContact {
  street: string,
  number?: string,
  city: string,
  province: string,
  country: string
}

export interface Shipment {
  typeShipment: string,
  price: string,
  date: string
}

/**
 * Estados finalizados que provienen de un evento POD de OCASA: solo en estos se muestra la constancia digital.
 * (VisitedNotCollected también viene de POD pero no es finalizado.) Debe coincidir con ConstanciaDigitalService.DigitalReceiptOcasaStatuses del back.
 */
export const DIGITAL_RECEIPT_STATUSES: string[] = [
  StatusShipment.delivered,
  StatusShipment.deliveredError,
  StatusShipment.incident,
  StatusShipment.returnDeliveryImpossible,
  StatusShipment.canceled
];

export const typeCardExtension = new Map<TypeStatusShipment, TypeCardExtension>([
  ['Dispatched', TypeCardExtension.onTravel],
  ['AtCenter', TypeCardExtension.onTravel],
  ['ReadyForPickup', TypeCardExtension.onTravel],
  ['DeliveringToday', TypeCardExtension.onTravel],
  ['InDistribution', TypeCardExtension.onTravel],
  ['Delivered', TypeCardExtension.finished],
  ['Cancelled', TypeCardExtension.errorPayment],
  ['DeliveryFailed', TypeCardExtension.finished],
  ['NotPickedUp', TypeCardExtension.finished],
  ['ReturnedToOrigin', TypeCardExtension.finished],
  ['ImpossibleReturn', TypeCardExtension.finished],
  ['ReportedIncident', TypeCardExtension.finished],
  ['NotDispatched', TypeCardExtension.finished],
  ['ReturnDispatched', TypeCardExtension.onTravel],
  ['ReturnDeliveryImpossible', TypeCardExtension.finished],
  ['ReturnReadyForPickup', TypeCardExtension.onTravel],
  ['Pending', TypeCardExtension.pendingPayment],
  ['Confirmed', TypeCardExtension.confirmed],
  ['ScheduledCollection', TypeCardExtension.confirmed],
  ['ToCollect', TypeCardExtension.confirmed],
  ['TakeToDropOff', TypeCardExtension.confirmed],
  ['ToPay', TypeCardExtension.errorPayment],
  ['Paid', TypeCardExtension.confirmed],
  ['CreditAccount', TypeCardExtension.confirmed],
  ['VisitedNotCollected', TypeCardExtension.confirmed],
  ['ImpossibleCollection', TypeCardExtension.finished]
]);

export function formatDate(dateString: string): string {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
}

export enum QueryParamsShipments {
  category = 'category',
  group = 'group'
}

export enum CategoryParam {
  pending = 'pending',
  shipment = 'shipment',
  return = 'return'
}

export enum GroupParam {
  pending = 'pending',
  all = 'all',
  confirm = 'confirm',
  send = 'send',
  in_transit = 'in-transit',
  completed = 'completed'
}


export interface ResponseListShipments {
  cards: ResponseShipmentsCard[],
  creditAccountInfo: CreditAccountInfo
}

export interface CreditAccountInfo {
  approvedLimit: number,
  availableLimit: number,
  hasCreditAccount: boolean,
  hasOverdueInvoices: boolean,
  reservedAmount: number,
  statusMessage: string
}

export interface ResponseShipmentsCard {
  id: number,
  isQuote: boolean,
  isManual?: boolean,
  externalPlatform: string | null,
  destinationName: string,
  destinationContact: string,
  destinationAddress: string,
  originName: string,
  originAddress: string,
  originContact: string,
  trackingCode: string | null,
  isReturn: boolean,
  paymentStatus: string,
  price: number,
  shipmentType: string,
  shipmentStatus: string | null,
  ocasaStatus: string | null,
  statusTimestamp: string,
  creationTimestamp: string,
  labelStatus?: string | null,
  digitalReceiptStatus?: DigitalReceiptStatus | null
}

export const SHIPMENTS = 'shipments';

export enum ShippingDelivery {
  standard = 'Standard',
  sameDay = 'SameDay',
  nextDay = 'NextDay',
  scheduled = 'Scheduled'
}

export enum StatehoodValues {
  pendingConfirm = "ToPay",
  pendingDispatch = "Confirmed",
  dispatched = "Dispatched",
  atCenter = "AtCenter",
  deliveredToday = "DeliveringToday",
  onTheWay = "InDistribution",
  ready = "ReadyForPickup",
  notRetired = "NotPickedUp",
  delivered = "Delivered",
  returnOrigin = "ReturnedToOrigin"
}

export enum ManagementValues {
  shipmentValue = 'shipment',
  returnValue = 'return'
}

export function parseDateStringToDate(dateStr: string, split: string): Date {
  const [day, month, year] = dateStr.split(split).map(Number);
  return new Date(year, month - 1, day);
}

export interface BackendError {
  status: number;
  timestamp: string;
  title: string;
  traceId: string;
  errorCode?: string;
  detail?: string;
  retriable?: boolean;
  context?: Record<string, unknown>;
}

export interface HttpErrorMessages {
  notFound?: string;
  server?: string;
  fallback?: string;
}

// Frases genéricas que devuelve el servidor sin cuerpo estructurado (no deben mostrarse tal cual al usuario).
const GENERIC_HTTP_REASON_PHRASES = new Set(['not found', 'internal server error', 'bad request', 'forbidden', 'unauthorized', 'service unavailable']);

// Traduce errores HTTP conocidos a mensajes en español, priorizando el detalle que envíe la API.
export function getHttpErrorMessage(error: HttpErrorResponse, messages: HttpErrorMessages = {}): string {
  const body = error?.error as unknown;
  const backendError = body && typeof body === 'object' ? body as Partial<BackendError> : undefined;

  if (backendError?.title) {
    return backendError.title;
  }

  const validationErrors = (body as { errors?: Record<string, string[]> } | undefined)?.errors;
  const firstValidationError = validationErrors ? Object.values(validationErrors)[0]?.[0] : undefined;
  if (firstValidationError) {
    return firstValidationError;
  }

  if (typeof body === 'string' && body.trim() && !GENERIC_HTTP_REASON_PHRASES.has(body.trim().toLowerCase())) {
    return body;
  }

  if (error.status === 404) {
    return messages.notFound ?? 'No encontramos el recurso solicitado.';
  }

  if (error.status >= 500) {
    const base = messages.server ?? 'Hubo un error al procesar la solicitud. Intenta nuevamente.';
    return backendError?.traceId ? `${base} (ID de referencia: ${backendError.traceId})` : base;
  }

  return messages.fallback ?? 'Ocurrió un error inesperado. Intenta nuevamente.';
}

export type ConfirmModalResult =
  | { click: 'filled' }
  | { click: 'outlined' };

export interface Login {
    reactivatedUser: boolean,
    token: string,
    statusCreditAccount: string,
  hasOverdueInvoices: boolean
}

export interface RefreshToken {
    token: string,
    statusCreditAccount: string,
  hasOverdueInvoices: boolean
}

export interface KeyValue {
  key: string;
  value: string;
}

export interface IdValue {
  key: number;
  value: string;
}

export interface RegisterFormTranslation {
  activities: string[],
  labels: string[],
  noSchedule: string,
  placeholders: RegisterPlaceholders,
  sales: string[],
  subtitle: string[],
  title: string[],
  typePerson: KeyValue[],
  taxStatus: KeyValue[],
  countShipments: KeyValue[]
}

export interface RegisterPlaceholders {
  activity: string,
  business: string,
  company: string,
  from: string,
  others: string,
  salesChannel: string,
  to: string,
  typePerson: string,
  taxStatus: string,
  countShipments: string
}

export interface TabsTranslation {
  all: string;
  confirm: string;
  dispatch: string;
}

export type PackageSizeOption = 'small' | 'medium' | 'big' | 'other' | '';

export enum ZipcodeError {
  pickitEmpty = 'pickitEmpty',
  pickitUnavailable = 'pickitUnavailable'
}

export enum PickitPointsOption {
  origin = 'despacho',
  destination = 'destino'
}

export enum ButtonPosition {
  right = 'right',
  under = 'under'
}